module.exports = __webpack_public_path__ + "img/Icon_CartaAfirmativa_PEI.c59ab71b.svg";